import React from "react"

// Overflow boolean checker
function isOverflown(element) {
    return element.scrollHeight > element.clientHeight;
}

function formatChangeLog(data) {
    return `Version ${data.version.name} published on ${new Date(data.version.createdAt).toLocaleDateString()} (engine version: ${data.version.editorVersion || 'unknown'}).`
}

class ChangeLog extends React.Component {
    constructor() {
        super()
        this.state = {
            expanded: false,
            buttonHidden: false,
            userIsOwner: null,
            edit: false
        }
        this.lineHeight = 24
        this.minLines = 10
        this.preferredHeight = this.lineHeight * this.minLines
        this.checkEleHeight = this.checkEleHeight.bind(this)
        this.handleResize = this.handleResize.bind(this)
    }
    checkEleHeight() {
        //check if I need to collapse the item
        const text = document.querySelector(".changeLog p")
        const height = text.offsetHeight;
        //if the element height is smaller than the
        if (height < this.preferredHeight && !isOverflown(text)) this.setState({ expanded: true, buttonHidden: true })
        else this.setState({ buttonHidden: false })
    }
    handleResize() {
        this.checkEleHeight()
    }
    componentDidMount() {
        this.checkEleHeight()
        window.addEventListener("resize", this.handleResize)
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize)
    }
    render() {
        console.log(this.props.data);
        const { data } = this.props
        const { expanded } = this.state
        const toggleClass = expanded ? "expanded" : "collapsed"
        return (
            <div className="changeLog section">
                <div className="sectionTitle">
                    <h2 className="sectionTitle">Change Log</h2>
                </div>
                {
                    data.version == null
                        ? (<p className="description">
                            "There hasn't been any versions to the game yet."
                        </p>)
                        : <div className={`description ${toggleClass}`}>
                            <p>{formatChangeLog(data)}</p>
                            <div className="expandBtn" onClick={() => this.setState(prevState => { return { expanded: !prevState.expanded } })}>
                                {expanded ? 'Read Less' : 'Read More'}
                            </div>
                        </div>
                }
            </div>
        )
    }
}

export default ChangeLog